module.exports = __webpack_public_path__ + "media/images/svg/newsletter-47aa5a5eb2c756dbcea794102372da35.svg";